import { AnalyticsContextValue } from "@swiggy-private/checkout-core";
import { SCREEN_NAME, CLICK_ACTIONS, IMPRESSION_ACTIONS } from "../constants";

interface MROTabCartRef {
    originalCartId: number | string;
    rid: number | string;
}

const buildMROTabsContext = (parentCartId: number | string, carts: MROTabCartRef[]): string =>
    JSON.stringify({
        // eslint-disable-next-line @typescript-eslint/naming-convention
        parent_cart_id: parentCartId,
        carts: carts.map(({ originalCartId, rid }) => ({
            // eslint-disable-next-line @typescript-eslint/naming-convention
            original_cart_id: originalCartId,
            rid,
        })),
    });

export const impressionMROSelectedTabs = ({
    impressionEvent,
    parentCartId,
    selectedCartIds,
    carts,
}: {
    impressionEvent: AnalyticsContextValue["impressionEvent"];
    parentCartId: number | string;
    selectedCartIds: Array<number | string>;
    carts: MROTabCartRef[];
}): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_MRO_SELECTED_TAB,
        label: JSON.stringify(selectedCartIds),
        context: buildMROTabsContext(parentCartId, carts),
    });
};

export const impressionMROFtue = ({
    impressionEvent,
    parentCartId,
    selectedCartIds,
    carts,
}: {
    impressionEvent: AnalyticsContextValue["impressionEvent"];
    parentCartId: number | string;
    selectedCartIds: Array<number | string>;
    carts: MROTabCartRef[];
}): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_MRO_FTUE_SELECTED_TAB,
        label: JSON.stringify(selectedCartIds),
        context: buildMROTabsContext(parentCartId, carts),
    });
};

export const impressionMROMinCartSelectError = ({
    impressionEvent,
    parentCartId,
    selectedCartIds,
    carts,
}: {
    impressionEvent: AnalyticsContextValue["impressionEvent"];
    parentCartId: number | string;
    selectedCartIds: Array<number | string>;
    carts: Array<{ cartId: number | string; rid: number | string }>;
}): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_MRO_MIN_CART_SELECT_ERROR,
        label: JSON.stringify(selectedCartIds),
        context: JSON.stringify({
            // eslint-disable-next-line @typescript-eslint/naming-convention
            parent_cart_id: parentCartId,
            carts: carts.map(({ cartId, rid }) => ({
                // eslint-disable-next-line @typescript-eslint/naming-convention
                cart_id: cartId,
                rid,
            })),
        }),
    });
};

export const clickMROSelectTab = ({
    clickEvent,
    parentCartId,
    cartId,
    originalCartId,
    rid,
}: {
    clickEvent: AnalyticsContextValue["clickEvent"];
    parentCartId: number | string;
    cartId: number | string;
    originalCartId: number | string;
    rid: number | string;
}): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_MRO_SELECT_TAB,
        label: String(cartId),
        context: JSON.stringify({
            // eslint-disable-next-line @typescript-eslint/naming-convention
            parent_cart_id: parentCartId,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            original_cart_id: originalCartId,
            rid,
        }),
    });
};
